// @owners { team: patient-health }
// eslint-disable-next-line @alto/no-pocky-import
import { Button } from '@alto/pocky';
import React from 'react';

type Props = {
  readonly navigateToFork: () => void;
  readonly recordButtonClick: () => void;
};

const MedListAddMedicationButton = ({ navigateToFork, recordButtonClick }: Props) => (
  <Button
    kind="secondary"
    onClick={() => {
      navigateToFork();
      recordButtonClick();
    }}
  >
    Add Medications
  </Button>
);

export default MedListAddMedicationButton;
